import { useI18n } from 'utils/i18n';
import { useItemHandleFragment$data } from './__generated__/useItemHandleFragment.graphql';

export const usePublishDate = (item: useItemHandleFragment$data) => {
  const { format } = useI18n();

  const DATE_FORMAT = 'MMMM do y';

  switch (item.__typename) {
    case 'VaultItem':
      return item.uploadGroup
        ? format(item.uploadGroup.publishedAt.utcDate, DATE_FORMAT)
        : null;
    default:
      return item.publishedAt ? format(item.publishedAt, DATE_FORMAT) : null;
  }
};
